<script>
import AppCashback from "./cashback.vue";

export default {
  name: "AppCashbackMain",

  components: {
    AppCashback,
  },
};
</script>

<template>
  <app-cashback />
</template>
